<template>
  <div class="information-content">
    <div class="information-title">
      <div class="level-title">{{ info.name }}</div>
      <i class="el-icon-error icon-error" @click="clearInfo"></i>
    </div>

    <div class="information-card">
      <div class="information-card-item" v-if="info.parkCode != 'DZXQ'">
        <span class="information-name">园区级别：</span>
        <span class="information-num">{{ info.parkLevelName }}</span>
      </div>
      <div class="information-card-item">
        <span class="information-name">基础设施：</span>
        <span class="information-num">{{
          info.infrastructureName ? info.infrastructureName : "--"
        }}</span>
      </div>
      <div class="information-card-item">
        <span class="information-name">联系人：</span>
        <span class="information-num">{{ info.person }}</span>
      </div>
      <div class="information-card-item">
        <span class="information-name">联系电话：</span>
        <span class="information-num">{{ info.phone }}</span>
      </div>

      <div class="information-card-item1">
        <span class="information-name">主导或特色产业：</span>
        <span class="information-num1">
          <!-- {{ info.leadingIndustry }} -->
          <span v-for="(itm, inx) in info.labels" :key="itm.labelId">
            {{ itm.labelName }} <i v-if="inx <= info.labels.length - 2">、</i>
          </span>
        </span>
      </div>
    </div>
    <div class="information-but">
      <el-button size="mini" type="primary" @click="goUrl">查看详情</el-button>
      <el-button size="mini" type="primary" @click="historical"
        >历史变迁</el-button
      >
    </div>
  </div>
</template>

<script>
import { createChartDom, removeChartDom } from "@/pulgin/createPulgin";
export default {
  name: "parkInfo",
  props: {
    info: {
      type: Object,
    },
    routerData: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    clearInfo() {
      removeChartDom();
    },
    goUrl() {
      window.sessionStorage.setItem(
        "breadcrumbNavDataStore",
        '[{"name":"云上选地","path":"/needLand/indexCopy","query":{}}]'
      );
      this.routerData.push({
        path: "/parkDetail",
        query: { id: this.info.id },
      });
      // this.$eventBus.on("parkDetailInfo",true)
    },
    historical() {
      this.$eventBus.emit("historicalChanges", true);
    },
  },
};
</script>

<style scoped>
.information-content {
  background: #ffffff;
  padding: 10px;
  border-radius: 4px;
  border: 2px solid #d9d9d9;
  width: 350px;
}
.information-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.level-title {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.level-title::before {
  content: "";
  display: block;
  width: 4px;
  height: 16px;
  margin-right: 10px;
  background: #046eff;
}
.icon-error {
  font-size: 20px;
  color: #046eff;
  cursor: pointer;
}
.information-type {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.type-left {
  background: red;
  padding: 2px 10px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
}
.type-left1 {
  background: #009ee7;
}
.type-left2 {
  background: #01ba61;
  margin-left: 10px;
}
.information-main {
  background: #f8f8f8;
  line-height: 25px;
  font-size: 14px;
  color: #8a8a8a;
  padding: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.information-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
}
.information-card-item {
  width: 50%;
  margin-top: 6px;
  display: flex;
  align-items: center;
}
.information-card-item1 {
  width: 100%;
  margin-top: 6px;
  display: flex;
  /* align-items: center; */
}
.information-name {
  font-size: 14px;
  color: #626262;
  /*width: 120px;*/
}
.information-num1 {
  margin-left: 10px;
  font-size: 14px;
  color: black;
  flex: 1;
}
.information-num {
  margin-left: 10px;
  font-size: 14px;
  color: black;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.information-but {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>